export function padNumber(value: number): string {
  return value.toString().padStart(2, '0');
}

export const easeOutStrong = [0.23, 1, 0.32, 1] as const;

